import React, { useState } from "react";
import { templates } from "./template-options";
import "./templates.css";

function Templates({ updateState }) {
	const [currentActive, setActive] = useState(-1);
	const handleButtonClick = (templateState, index) => {
		setActive(index);
		updateState(templateState);
	}

	return (
		<React.Fragment>
			<h1 className="content-title" id="templates">Templates</h1>
			<p className="disclaimer">
				The following templates can serve as a starting point for your setup. Please note that they may not exactly match operational setups.
			</p>
			<div className="templates-container">
				{templates.map((template, index) => {
					return (
						<div key={index} className={index === currentActive ? "template-button active" : "template-button"} onClick={() => handleButtonClick(template.state, index)}>{template.name}</div>
					)
				})
				}
			</div>
		</React.Fragment>
	);
}

export default Templates; 
